export default {
	SET_BREADCRUMBS_OPENED: "SET_BREADCRUMBS_OPENED",
	SET_ROLES: "SET_ROLES",
	SET_FEATURES: "SET_FEATURES",
	SET_LABELMAPPINGS: "SET_LABELMAPPINGS",
	SET_PROFILE_ATTRIBUTES: "SET_PROFILE_ATTRIBUTES",
	SET_MQTT_CREDENTIALS: "SET_MQTT_CREDENTIALS",
	MQTT_SUBSCRIBE: "MQTT_SUBSCRIBE",
	MQTT_UNSUBSCRIBE: "MQTT_UNSUBSCRIBE",
	ADD_TOAST: "ADD_TOAST",
	DISMISS_TOAST: "DISMISS_TOAST",
	SET_USERNAME: "SET_USERNAME",
	SET_MAP_ZOOM: "SET_MAP_ZOOM",
	SET_MAP_CENTER: "SET_MAP_CENTER",
	SET_TILE_PROVIDER_VISIBILITY: "SET_TILE_PROVIDER_VISIBILITY",
	SET_PRIMARY_CLIENT: "SET_PRIMARY_CLIENT"
};
